import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CalendarDaysIcon, CheckIcon, Clock3Icon, CookingPotIcon, DownloadIcon, LeafIcon, LockKeyholeIcon, MonitorSmartphoneIcon, NotebookPenIcon, SaladIcon, SparklesIcon, ZapIcon } from 'lucide-react';
import { checkoutUrl, handleCheckoutClick } from '../utils/checkout';
const products = [{
  label: 'PRODUCTO PRINCIPAL',
  title: 'Hábitos para una Vida Saludable',
  icon: BookOpenIcon,
  description: 'Tu punto de partida para dejar de improvisar y sentir calma frente a la comida.',
  image: 'https://cdn.magicpatterns.com/uploads/8qqeT9itbTEfWdJ6h8w9LR/ChatGPT_Image_17_jul_2026,_09_37_05.png',
  benefits: ['Saber qué elegir sin dudar', 'Pasos pequeños que sí se sostienen', 'Semanas resueltas con calma', 'Tus primeros 30 días listos', 'Ideas para cada momento del día', 'Menús que no tienes que pensar', 'Menos tiempo en la cocina', 'Todo explicado con claridad'],
  featured: true
}, {
  label: 'BONO PREMIUM #1',
  title: 'Cocina Antiinflamatoria',
  icon: SaladIcon,
  description: 'Está aquí para los días en que te cansas de comer siempre lo mismo. Sabores nuevos, ingredientes de siempre.',
  image: 'https://cdn.magicpatterns.com/uploads/ew4zYGVwXbmFnKLfyms136/bono_3_CF.png',
  benefits: ['Desayunos que dan ganas de levantarse', 'Almuerzos y cenas sin repetir', 'Snacks para el antojo de la tarde', 'Jugos verdes y smoothies fáciles', 'Postres que sí puedes disfrutar', 'Todo con ingredientes de tu súper'],
  featured: false
}, {
  label: 'BONO PREMIUM #2',
  title: 'Recetario Déficit Calórico',
  icon: CookingPotIcon,
  description: 'Existe para que comer ligero deje de sentirse como un castigo. Platos que llenan, sin contar cada bocado.',
  image: 'https://cdn.magicpatterns.com/uploads/wzKGsUFS67E9tmbeSAkRpg/bono_2_CF.png',
  benefits: ['Más de 120 opciones para elegir', 'Platos que sacian de verdad', 'Listos en menos de 30 minutos', 'Para cada momento del día', 'Postres para el antojo dulce', 'Con la información que necesitas'],
  featured: false
}, {
  label: 'BONO PREMIUM #3',
  title: 'Planificador Nutricional',
  icon: CalendarDaysIcon,
  description: 'Está pensado para las semanas caóticas: escribes tu plan una vez y dejas de decidir a las siete de la tarde.',
  image: 'https://cdn.magicpatterns.com/uploads/qa3vi2EPaBMrMf36ySks4p/bono_1_CF.png',
  benefits: ['Tu semana lista en unos minutos', 'Lista de compras sin olvidos', 'Recordatorio de agua y movimiento', 'Un lugar para ver tu avance', 'Espacio para tus notas', 'Metas pequeñas y realistas'],
  featured: false
}];
const learning = [['Comer sin extremos ni culpa', LeafIcon], ['Saber qué hay para cenar', NotebookPenIcon], ['Sostenerlo cuando falla el ánimo', SparklesIcon], ['Empezar la mañana sin prisa', CookingPotIcon], ['Resolver el almuerzo en minutos', SaladIcon], ['Cenar rico sin pensarlo tanto', CookingPotIcon], ['Tener algo listo para el antojo', SaladIcon], ['Ganar tiempo el resto de la semana', Clock3Icon], ['Comer ligero sin pasar hambre', LeafIcon], ['Salir de las mismas cinco comidas', SparklesIcon], ['Sentirte liviana por dentro', SaladIcon], ['Disfrutar de nuevo lo que comes', LeafIcon]];
export function OfferLearning() {
  return <>
      <section id="incluye" className="relative overflow-hidden bg-[#fffefa] pb-16 pt-8 sm:pb-20 sm:pt-10" data-id="element-178" data-mp="2v9i9h49aqpel">
        <LeafIcon aria-hidden="true" className="absolute -right-10 top-40 h-36 w-36 rotate-[24deg] text-[#e2eadc]" strokeWidth={0.9} data-id="element-179" data-mp="301083lnukdwe" />
        <div className="relative mx-auto max-w-7xl px-5 sm:px-8" data-id="element-180" data-mp="27je2qo0ta9jd">
          <header className="mx-auto max-w-4xl text-center" data-id="element-181" data-mp="27hkvp7madnau">
            <p className="text-xs font-bold tracking-[0.2em] text-[#6d8063]" data-id="element-182" data-mp="d48pqptzn79q">
              ESTO ES LO QUE CAMBIA
            </p>
            <h2 className="font-display mt-5 text-4xl leading-tight text-[#2d3b2c] sm:text-5xl" data-id="element-183" data-mp="8zr74tzd700j">
              Imagina una semana en la que comer bien no te cueste nada.
            </h2>
            <div className="mx-auto mt-7 max-w-3xl space-y-5 text-lg leading-8 text-[#63705f]" data-id="element-184" data-mp="i0z1x22o9ipv">
              <p data-id="element-185" data-mp="wpvad08n4xr0">Abres la nevera y ya sabes qué vas a preparar.</p>
              <p data-id="element-186" data-mp="rt4t49l3nw40">
                Comes tranquila, disfrutas lo que tienes en el plato y sigues con
                tu día sin darle mil vueltas.
              </p>
            </div>
          </header>

          <motion.article initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.1
        }} transition={{
          duration: 0.55
        }} className="mt-16 overflow-hidden border border-[#e0e4da] bg-[#fcfbf7] shadow-[0_12px_34px_rgba(53,70,49,0.07)] lg:grid lg:grid-cols-[.76fr_1.24fr] lg:items-stretch" data-id="element-187" data-mp="10sryt7kv3o2v">
            <div className="relative flex min-h-[420px] items-center justify-center bg-[#eef1e7] p-8 sm:p-12 lg:min-h-[640px]" data-id="element-188" data-mp="197xw2ikp6hen">
              <span className="absolute left-6 top-6 bg-[#fffefa] px-3 py-2 text-[10px] font-bold tracking-[0.16em] text-[#52664c] shadow-sm" data-id="element-189" data-mp="zc4g0p7rs5s4">
                PRODUCTO PRINCIPAL
              </span>
              <img src={products[0].image} alt="Portada de la guía Hábitos para una Vida Saludable" className="relative h-auto max-h-[530px] w-auto max-w-[330px] object-contain shadow-[14px_20px_32px_rgba(38,48,35,0.22)] sm:max-w-[400px]" data-id="element-190" data-mp="qbg17sajy1e6" />
            </div>

            <div className="p-8 sm:p-12 lg:p-14" data-id="element-191" data-mp="2oprd29sbaf2m">
              <div className="flex items-center gap-3 text-[#66805c]" data-id="element-192" data-mp="2oogb8fiffhe5">
                <LeafIcon size={21} strokeWidth={1.5} aria-hidden="true" data-id="element-193" data-mp="1jwmant3q3kx" />
                <p className="text-[11px] font-bold tracking-[0.16em]" data-id="element-194" data-mp="3snl9y3ojhum4">
                  🌿 TU PUNTO DE PARTIDA
                </p>
              </div>
              <h3 className="font-display mt-5 text-3xl text-[#30452e] sm:text-4xl" data-id="element-195" data-mp="3oovzojysst6p">
                Hábitos para una Vida Saludable
              </h3>
              <p className="mt-4 max-w-xl text-lg leading-8 text-[#42573f]" data-id="element-196" data-mp="k7rwxytf319t">
                El acompañamiento que te faltaba para que cuidarte deje de ser
                una lucha diaria.
              </p>

              <div className="mt-7 max-w-2xl space-y-4 leading-7 text-[#62705f]" data-id="element-197" data-mp="bf8093wor6rm">
                <p data-id="element-198" data-mp="6gdb7k84klz2">
                  Aquí termina el “¿qué cocino hoy?” y empieza una rutina que no
                  depende de tener un día perfecto.
                </p>
                <p data-id="element-199" data-mp="z6dhnni9y741">
                  Si probaste de todo y nada duró, este es un comienzo distinto:
                  simple, amable y hecho para tu vida real.
                </p>
              </div>

              <h4 className="mt-9 text-[11px] font-bold uppercase tracking-[0.16em] text-[#52664c]" data-id="element-200" data-mp="1bg38dbxq2bkq">
                Lo que vas a sentir:
              </h4>
              <ul className="mt-5 grid gap-x-7 gap-y-3 sm:grid-cols-2" data-id="element-201" data-mp="1ge4obnzupurz">
                {['Comer sin la sensación de estar a dieta.', 'Llegar a casa y saber qué preparar.', 'Cocinar sin estrés, incluso con prisa.', 'Sentarte a la mesa sin culpa.', 'Tener tus 30 primeros días ya resueltos.', 'Recuperar horas cada semana.', 'Comprar sin dar vueltas en el súper.', 'Sentir que esta vez sí lo sostienes.'].map(benefit => <li key={benefit} className="flex items-start gap-2.5 text-sm leading-6 text-[#586655]" data-id="element-202" data-mp="2886rg76a17ck">
                    <CheckIcon className="mt-1 shrink-0 text-[#719063]" size={15} strokeWidth={2} data-id="element-203" data-mp="2yfu9ql0j39eg" />
                    <span data-id="element-204" data-mp="38fcswz8m6r5g">{benefit}</span>
                  </li>)}
              </ul>

              <aside className="mt-9 rounded-2xl border border-[#d8e5d0] bg-[#eff5ea] p-6 sm:p-7" data-id="element-205" data-mp="33f6y5a71soj5">
                <h4 className="font-display text-2xl text-[#354a33]" data-id="element-206" data-mp="2fpmeep32ln8t">
                  Lo mejor: no tienes que renunciar a nada
                </h4>
                <div className="mt-4 space-y-2.5 text-sm leading-6 text-[#53634e]" data-id="element-207" data-mp="2asvvzv3smfk8">
                  <p data-id="element-208" data-mp="2phibbwtf77bg">No tienes que vigilar cada bocado.</p>
                  <p data-id="element-209" data-mp="2kop7db5s030f">No tienes que dejar lo que más disfrutas.</p>
                  <p data-id="element-210" data-mp="2kn5t1q3ok21a">No tienes que ser constante al cien por ciento.</p>
                  <p className="font-semibold text-[#405a3b]" data-id="element-211" data-mp="1wy3amg18255q">
                    Solo necesitas saber por dónde empezar mañana.
                  </p>
                </div>
              </aside>

              <div className="mt-7" data-id="element-212" data-mp="7hqzte48j7gy">
                <a href={checkoutUrl} onClick={handleCheckoutClick} className="inline-flex min-h-14 w-full items-center justify-center rounded-full bg-[#405a3b] px-7 text-center text-sm font-bold tracking-[0.06em] text-white shadow-[0_10px_20px_rgba(48,69,46,0.14)] transition duration-300 hover:-translate-y-0.5 hover:bg-[#304a2d] hover:shadow-[0_14px_25px_rgba(48,69,46,0.2)] sm:w-auto" data-id="element-213" data-mp="7gpl8zo0g2uh">
                  🍃 QUIERO EMPEZAR HOY
                </a>
                <div className="mt-4 flex flex-wrap gap-x-3 gap-y-2 text-xs font-medium text-[#64745f]" data-id="element-214" data-mp="h8lu95rmxddh">
                  <span data-id="element-215" data-mp="l9e5g4k2hsce">🔒 Pago 100% seguro</span>
                  <span className="text-[#9aa893]" data-id="element-216" data-mp="l847rgh4mm6a">•</span>
                  <span data-id="element-217" data-mp="31yb8phofex5n">⚡ Acceso inmediato</span>
                  <span className="text-[#9aa893]" data-id="element-218" data-mp="320nr1vy3j9j8">•</span>
                  <span data-id="element-219" data-mp="3617kaofjtt03">📥 Descarga digital</span>
                  <span className="text-[#9aa893]" data-id="element-220" data-mp="35xtltra0a3xx">•</span>
                  <span data-id="element-221" data-mp="5xsug7uzf9p2">📱 Compatible con celular, tablet y computadora</span>
                  <span className="text-[#9aa893]" data-id="element-222" data-mp="avueow459f24">•</span>
                  <span data-id="element-223" data-mp="axf82ieq2rye">💚 Pago único</span>
                </div>
                <p className="font-display mt-7 max-w-2xl text-xl leading-8 text-[#3e573a] sm:text-2xl" data-id="element-224" data-mp="3t92ah78nx99w">
                  No tienes que cambiar tu vida en un día. Solo sostener
                  pequeñas decisiones hasta que cuidarte se sienta natural.
                </p>
              </div>
            </div>
          </motion.article>

          <aside className="relative mx-auto mt-14 max-w-5xl overflow-hidden rounded-[28px] border border-[#d8e2d2] bg-[#f2f5ec] px-6 py-12 text-center shadow-[0_14px_32px_rgba(55,75,49,0.08)] sm:px-12 sm:py-16" aria-labelledby="bonuses-introduction-title" data-id="element-225" data-mp="3aapogkwnk4ww">
            <LeafIcon aria-hidden="true" className="absolute -left-5 top-7 h-24 w-24 -rotate-[28deg] text-[#b7caaa]/45" strokeWidth={1} data-id="element-226" data-mp="18hic9kcc63f8" />
            <LeafIcon aria-hidden="true" className="absolute -right-5 bottom-7 h-28 w-28 rotate-[32deg] text-[#c9d8bb]/55" strokeWidth={1} data-id="element-227" data-mp="2x0w5tjx40xar" />
            <div className="relative mx-auto max-w-3xl" data-id="element-228" data-mp="36uv9incu0p4t">
              <div className="flex items-center justify-center gap-3 text-[#657d5c]" data-id="element-229" data-mp="3210qzn8yqg7b">
                <span aria-hidden="true" className="h-px w-10 bg-[#9db093]" data-id="element-230" data-mp="3gq6on6s5jyd3" />
                <p className="text-[11px] font-bold tracking-[0.18em]" data-id="element-231" data-mp="3bs55ymyn2125">
                  Y esto es solo el comienzo…
                </p>
                <span aria-hidden="true" className="h-px w-10 bg-[#9db093]" data-id="element-232" data-mp="3pql800lk33dy" />
              </div>
              <h3 id="bonuses-introduction-title" className="font-display mt-5 text-3xl leading-tight text-[#30452e] sm:text-4xl" data-id="element-233" data-mp="3ktmk3zshjso7">
                Tu cambio también merece herramientas que te acompañen
              </h3>
              <p className="mx-auto mt-6 max-w-3xl leading-7 text-[#5e6d58] sm:text-lg sm:leading-8" data-id="element-234" data-mp="3qh1m5uxfw6lr">
                Al adquirir Hábitos para una Vida Saludable, también recibirás{' '}
                <span className="font-bold text-[#3f683d]" data-id="element-235" data-mp="49l8zf597kle">
                  tres bonos premium incluidos sin costo adicional
                </span>
                , creados para ayudarte a organizarte mejor, disfrutar comidas
                deliciosas y convertir tus nuevos hábitos en una forma de vida más
                sencilla y sostenible.
              </p>
              <p className="font-display mt-7 text-xl text-[#405e3e] sm:text-2xl" data-id="element-236" data-mp="i7i7ih39q12p">
                Más apoyo. Más claridad. Más razones para comenzar hoy.
              </p>
              <div className="mx-auto mt-8 h-px w-20 bg-[#b6c9aa]" data-id="element-237" data-mp="ry4g3rckhrbw" />
              <p className="mt-6 text-sm font-semibold text-[#52684e] sm:text-base" data-id="element-238" data-mp="w1145xkvmfn8">
                Descubre todo lo que recibirás junto con tu producto principal:
              </p>
              <span aria-hidden="true" className="mx-auto mt-7 flex h-10 w-10 items-center justify-center rounded-full border border-[#aabda0] bg-[#fffefa] text-xl leading-none text-[#557250] shadow-sm" data-id="element-239" data-mp="2lhv99qkythha">
                ↓
              </span>
            </div>
          </aside>

          <div className="mt-10 grid gap-8 lg:grid-cols-2" data-id="element-240" data-mp="27in5ekduxl6r">
            {products.slice(1).map((product, index) => {
            const ProductIcon = product.icon;
            return <motion.article key={product.title} initial={{
              opacity: 0,
              y: 18
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.1
            }} transition={{
              duration: 0.5,
              delay: index * 0.05
            }} className="overflow-hidden border border-[#e0e4da] bg-[#fcfbf7] shadow-[0_12px_34px_rgba(53,70,49,0.07)]" data-id="element-241" data-mp="30699ruuwstuo" data-mpi={index}>
                  <div className="relative flex min-h-[350px] items-center justify-center bg-[#eef1e7] p-8 sm:min-h-[410px]" data-id="element-242" data-mp="2tpfvidbppoq8">
                    <span className="absolute left-6 top-6 bg-[#fffefa] px-3 py-2 text-[10px] font-bold tracking-[0.16em] text-[#52664c] shadow-sm" data-id="element-243" data-mp="2yo100oxzyukh">
                      {product.label}
                    </span>
                    <img src={product.image} alt={`Portada de ${product.title}`} className="relative h-auto max-h-[490px] w-auto max-w-[250px] object-contain shadow-[14px_20px_32px_rgba(38,48,35,0.22)] sm:max-w-[290px]" data-id="element-244" data-mp="3qenhfmg8tzuo" />
                  </div>
                  <div className="p-7 sm:p-9" data-id="element-245" data-mp="96acezzc406i">
                    <div className="flex items-center gap-3 text-[#66805c]" data-id="element-246" data-mp="dytpzwy0uvbb">
                      <ProductIcon size={21} strokeWidth={1.5} aria-hidden="true" data-id="element-247" data-mp="nd3vaa06f13e" />
                      <p className="text-[11px] font-bold tracking-[0.16em]" data-id="element-248" data-mp="j9fnbq7mu3hm">
                        {product.label}
                      </p>
                    </div>
                    <h3 className="font-display mt-5 text-3xl text-[#30452e]" data-id="element-249" data-mp="s553nku847o5">
                      {product.title}
                    </h3>
                    <p className="mt-4 max-w-xl leading-7 text-[#62705f]" data-id="element-250" data-mp="4g2msf7eyiup">
                      {product.description}
                    </p>
                    <h4 className="mt-8 text-[11px] font-bold uppercase tracking-[0.16em] text-[#52664c]" data-id="element-251" data-mp="ecp4ww8cuvt1">
                      Lo que te resuelve
                    </h4>
                    <ul className="mt-4 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-252" data-mp="1prc6ap6yvpxv">
                      {product.benefits.map(benefit => <li key={benefit} className="flex items-start gap-2 text-sm leading-6 text-[#586655]" data-id="element-253" data-mp="1krpu8j2vkfqn">
                          <CheckIcon className="mt-1 shrink-0 text-[#719063]" size={14} strokeWidth={2} data-id="element-254" data-mp="1wtr7j85a0azh" />
                          <span data-id="element-255" data-mp="26sgcy1fzk2yu">{benefit}</span>
                        </li>)}
                    </ul>
                  </div>
                </motion.article>;
          })}

            <motion.aside initial={{
            opacity: 0,
            y: 18
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.5,
            delay: 0.18
          }} className="overflow-hidden rounded-2xl border border-[#dfe5d8] bg-[#fffefa] shadow-[0_14px_35px_rgba(53,70,49,0.10)]" aria-labelledby="complete-system-title" data-id="element-256" data-mp="1e4kjd5lpqr6a">
              <div className="bg-[#f2f3eb] p-4 sm:p-6" data-id="element-257" data-mp="itcx4ny40p1z">
                <img src="https://cdn.magicpatterns.com/uploads/kwFw7QvCpLGEdkwY1o1dUk/ChatGPT_Image_17_jul_2026,_09_44_00.png" alt="Sistema Hábitos para una Vida Saludable con guía práctica, cocina antiinflamatoria, recetario déficit calórico y planificador nutricional" className="h-auto w-full rounded-xl object-contain shadow-[0_10px_25px_rgba(48,64,43,0.13)]" data-id="element-258" data-mp="dut7acgeat4c" />
              </div>
              <div className="p-7 sm:p-9" data-id="element-259" data-mp="3mbxpmlkm329v">
                <p className="text-[11px] font-bold tracking-[0.16em] text-[#66805c]" data-id="element-260" data-mp="3md8u6nlvse21">
                  PACK PREMIUM
                </p>
                <h3 id="complete-system-title" className="font-display mt-4 text-3xl leading-tight text-[#30452e]" data-id="element-261" data-mp="3henvisma22fp">
                  Todo junto, listo cuando lo necesites
                </h3>
                <p className="mt-4 leading-7 text-[#62705f]" data-id="element-262" data-mp="1a0l7lsenz0cx">
                  Nada de recursos sueltos ni capturas guardadas en el teléfono.
                  Todo en un mismo lugar, para que nunca te quedes sin una idea
                  clara a la hora de comer.
                </p>
                <p className="mt-4 leading-7 text-[#62705f]" data-id="element-263" data-mp="mbijc1piy99g">
                  Más de 550 opciones entre las que elegir, y la tranquilidad de
                  saber que siempre habrá algo que puedas preparar hoy.
                </p>

                <ul className="mt-7 grid gap-x-5 gap-y-2.5 sm:grid-cols-2" data-id="element-264" data-mp="cffhkwyl4cn1">
                  {['Tu guía para empezar con calma', 'Cocina Antiinflamatoria', 'Recetario Déficit Calórico', 'Planificador Nutricional', 'Ideas para cada momento del día', 'Tus primeros 30 días resueltos', 'Menos tiempo frente a la estufa', 'Listas listas para el súper', 'Lo tienes hoy mismo', 'A mano en cualquier dispositivo'].map(benefit => <li key={benefit} className="flex items-start gap-2 text-sm leading-6 text-[#586655]" data-id="element-265" data-mp="3oxq7y6dkiq6u">
                      <CheckIcon className="mt-1 shrink-0 text-[#719063]" size={14} strokeWidth={2} data-id="element-266" data-mp="7n0agct9yxrd" />
                      <span data-id="element-267" data-mp="gjrhtlda1z19">{benefit}</span>
                    </li>)}
                </ul>

                <div className="mt-8 inline-flex items-center gap-2 rounded-full border border-[#b9c9ad] bg-[#f2f6ed] px-4 py-2.5 text-xs font-bold tracking-[0.05em] text-[#486044]" data-id="element-268" data-mp="cifop5v72vob">
                  <CheckIcon size={15} strokeWidth={2} data-id="element-269" data-mp="len8ah2v8ec9" />
                  Puedes empezar esta misma noche
                </div>
              </div>
            </motion.aside>
          </div>

          <motion.aside initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.55
        }} className="mx-auto mt-16 max-w-5xl rounded-[22px] border border-[#c9d7c1] bg-[#dfe9d8] px-6 py-12 text-center shadow-[0_16px_38px_rgba(53,70,49,0.10)] sm:px-12 sm:py-16" aria-labelledby="launch-offer-title" data-id="element-270" data-mp="t051lhnxf38e">
            <p className="mx-auto inline-flex rounded-full bg-[#657b5b] px-4 py-2 text-[10px] font-bold tracking-[0.18em] text-[#fff8e8]" data-id="element-271" data-mp="k6rwzigi2d6h">
              🔥 OFERTA ESPECIAL DE LANZAMIENTO
            </p>

            <h3 id="launch-offer-title" className="font-display mx-auto mt-7 max-w-2xl text-3xl leading-tight text-[#30452e] sm:text-4xl" data-id="element-272" data-mp="3nmpde9598hd9">
              Menos de lo que gastas en una cena fuera.
            </h3>

            <div className="mt-9" data-id="element-273" data-mp="1t9cvqu3lgcwb">
              <p className="text-lg font-medium text-[#7b8375] line-through" data-id="element-274" data-mp="1taeezlurk5p4">
                $197 USD
              </p>
              <p className="font-display mt-1 text-6xl leading-none text-[#2f5432] sm:text-8xl" data-id="element-275" data-mp="1y5blal0ns0yb">
                $29.99 USD
              </p>
            </div>

            <p className="mx-auto mt-7 max-w-3xl text-base leading-7 text-[#4c6049] sm:text-lg" data-id="element-276" data-mp="2qv0mozha630g">
              Y a cambio, meses de decisiones más fáciles, comidas que disfrutas
              y una relación más tranquila con lo que pones en tu plato.
            </p>

            <div className="mt-7 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm font-semibold text-[#506548]" data-id="element-277" data-mp="11gvwir5dhvm9">
              <span data-id="element-278" data-mp="15k1xbj9puulc">Ahorras más del 80%</span>
              <span aria-hidden="true" className="text-[#93a58b]" data-id="element-279" data-mp="15gny2jwcn1i4">
                •
              </span>
              <span data-id="element-280" data-mp="336kzi5jqk5mt">Pago único</span>
              <span aria-hidden="true" className="text-[#93a58b]" data-id="element-281" data-mp="336baak6im2i6">
                •
              </span>
              <span data-id="element-282" data-mp="2yet8jtwo3xw5">Sin mensualidades</span>
              <span aria-hidden="true" className="text-[#93a58b]" data-id="element-283" data-mp="2ydi37pnkqi2x">
                •
              </span>
              <span data-id="element-284" data-mp="2texascekd2p1">Es tuyo para siempre</span>
              <span aria-hidden="true" className="text-[#93a58b]" data-id="element-285" data-mp="2pg7p7wjdgeub">
                •
              </span>
              <span data-id="element-286" data-mp="2kfabbw5ea6ym">Lo tienes en minutos</span>
            </div>

            <a href={checkoutUrl} onClick={handleCheckoutClick} className="mt-10 inline-flex min-h-16 items-center justify-center rounded-full bg-[#3f603d] px-8 text-center text-sm font-bold tracking-[0.06em] text-white shadow-[0_10px_20px_rgba(48,69,46,0.16)] transition duration-300 hover:-translate-y-0.5 hover:bg-[#304d30] hover:shadow-[0_14px_26px_rgba(48,69,46,0.22)] focus:outline-none focus:ring-2 focus:ring-[#496d46] focus:ring-offset-2 focus:ring-offset-[#dfe9d8]" data-id="element-287" data-mp="2fgqqy06g938d">
              QUIERO RECUPERAR EL CONTROL
            </a>

            <div className="mx-auto mt-8 flex max-w-3xl flex-wrap justify-center gap-x-6 gap-y-4 text-xs font-medium text-[#50614b]" data-id="element-288" data-mp="q04utnzd4mk8">
              <span className="inline-flex items-center gap-2" data-id="element-289" data-mp="uxwmcgw3i6nw">
                <LockKeyholeIcon size={15} aria-hidden="true" data-id="element-290" data-mp="3uecq9u70adg0" />
                Pago 100% seguro
              </span>
              <span className="inline-flex items-center gap-2" data-id="element-291" data-mp="29in5xt9t4ar">
                <ZapIcon size={15} aria-hidden="true" data-id="element-292" data-mp="2c3q6q5b1qa3" />
                Acceso inmediato
              </span>
              <span className="inline-flex items-center gap-2" data-id="element-293" data-mp="c8gknq8oc85w">
                <DownloadIcon size={15} aria-hidden="true" data-id="element-294" data-mp="c9rn9mqdv9vf" />
                Descarga digital
              </span>
              <span className="inline-flex items-center gap-2" data-id="element-295" data-mp="1iqmz2sbtotz8">
                <MonitorSmartphoneIcon size={15} aria-hidden="true" data-id="element-296" data-mp="1nmbxgsc3w4ty" />
                Compatible con celular, tablet y computadora
              </span>
            </div>
          </motion.aside>

          <div className="mx-auto mt-8 max-w-6xl border-l-2 border-[#809675] bg-[#f7f8f2] px-7 py-7 sm:px-10" data-id="element-297" data-mp="2rmikvns5r324">
            <p className="text-xs font-bold tracking-[0.18em] text-[#667d5c]" data-id="element-298" data-mp="35mtfn1wl91sk">
              LO QUE TE LLEVAS HOY
            </p>
            <div className="mt-4 grid gap-4 text-sm leading-6 text-[#53634e] sm:grid-cols-2 lg:grid-cols-4" data-id="element-299" data-mp="30oi6yui14xbx">
              {['Claridad para saber qué comer', 'Tus primeros 30 días resueltos', 'Semanas más ordenadas y ligeras', 'Todo a mano, estés donde estés'].map(value => <p key={value} className="flex items-start gap-2" data-id="element-300" data-mp="3kbfruuqx5dfk">
                  <CheckIcon className="mt-1 shrink-0 text-[#6d8662]" size={15} strokeWidth={2} data-id="element-301" data-mp="240753io3359" />
                  <span data-id="element-302" data-mp="gr8mmgj0dun1">{value}</span>
                </p>)}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#fcfbf7] pb-16 pt-10 sm:pb-20 sm:pt-12" data-id="element-303" data-mp="lql8oz222xok">
        <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-304" data-mp="6t2irtdn6efj">
          <div className="flex flex-col justify-between gap-6 sm:flex-row sm:items-end" data-id="element-305" data-mp="6sj5ipyxse7u">
            <div data-id="element-306" data-mp="bqufr1t58qql">
              <p className="text-xs font-bold tracking-[0.2em] text-[#6d8063]" data-id="element-307" data-mp="bqawnhrrbwaz">
                LO QUE CAMBIA EN TU SEMANA
              </p>
              <h2 className="font-display mt-5 text-4xl text-[#2d3b2c] sm:text-5xl" data-id="element-308" data-mp="2rz5nemzawi0">
                ¿Cómo se sentirá tu día a día?
              </h2>
            </div>
            <p className="max-w-sm leading-7 text-[#64705f]" data-id="element-309" data-mp="3k64a1nqskrnt">
              Pequeños cambios que, sin darte cuenta, terminan siendo tu nueva
              forma de vivir.
            </p>
          </div>
          <div className="mt-12 grid gap-px border border-[#e1e3db] bg-[#e1e3db] sm:grid-cols-2 lg:grid-cols-3" data-id="element-310" data-mp="3b9mxcg2s4lpy">
            {learning.map(([title, Icon]) => {
            const LearningIcon = Icon as typeof LeafIcon;
            return <div key={title as string} className="flex min-h-36 items-center gap-5 bg-[#fcfbf7] p-7" data-id="element-311" data-mp="1gydqd7tm395p">
                  <LearningIcon className="text-[#658057]" size={24} strokeWidth={1.5} data-id="element-312" data-mp="17191v1can1lq" />
                  <span className="text-base font-medium text-[#465342]" data-id="element-313" data-mp="24o81nkya8pnu">
                    {title as string}
                  </span>
                </div>;
          })}
          </div>
        </div>
      </section>
    </>;
}